import { generateCrud } from './helpers'

export default function () {
  return {
    read: generateCrud('/api/account_users').read,
    search: generateCrud('/api/account/users').read
  }
}
